var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"left-nav"},[_c('div',{staticClass:"left-nav__title"},[_c('p',[_vm._v(_vm._s(_vm.currentModule.title))]),_c('p',[_vm._v(_vm._s(_vm.currentModule.title_en))])]),_c('div',{staticClass:"left-nav__list"},[_c('ul',_vm._l((_vm.currentModule.children),function(nav){return _c('router-link',{key:nav.title,staticClass:"left-nav__item",class:{
					'left-nav__item--active': _vm.$route.path.includes(
						nav.name
					),
				},attrs:{"to":nav.path,"tag":"li"}},[_c('span',[_vm._v(_vm._s(nav.title))])])}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }